module.exports = __webpack_public_path__ + "static/img/6-1.6d364c2f.png";